import { getContentGatewayUrl } from '@casumo/fabric-fundamentals';
import { CONTENT_GATEWAY_URL } from '../utils/envConstants.ts';
import { gatekeeper } from '../utils/gatekeeper.ts';

const PAYLOAD_PROXY_PATH = '/cms/p/v1';

const PROD_ORIGIN = /^https:\/\/(www\.)?casumo\.(com|es)$/;

type TGatewayGatekeeper = Parameters<typeof getContentGatewayUrl>[0];

export type TContentEnvironment = 'prod' | 'test';

export const contentEnvironment = (): TContentEnvironment =>
  PROD_ORIGIN.test(window?.location?.origin ?? '') ? 'prod' : 'test';

export const gatewayUrl = (): URL => getContentGatewayUrl({
  ...gatekeeper,
  staticContext: {
    ...gatekeeper?.staticContext,
    gatewayBaseUrl: gatekeeper?.staticContext?.gatewayBaseUrl || CONTENT_GATEWAY_URL,
  },
} as unknown as TGatewayGatekeeper);

export const buildPayloadUrl = (
  collection: string,
  params: Record<string, string> = {},
): URL => {
  const url = gatewayUrl();

  url.pathname = `${url.pathname.replace(/\/+$/, '')}${PAYLOAD_PROXY_PATH}/${contentEnvironment()}/${collection}`;

  Object.entries(params).forEach(([key, value]) => url.searchParams.set(key, value));

  return url;
};
